//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import {Filter, IFilter, TrafficManagementClientBase} from './TrafficManagementClientBase';
import {throwException, isAxiosError} from './TrafficManagementClientBase';
import {MNullable} from '../Toolkit/Utils';

export class RequestClient extends TrafficManagementClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: MNSwagClientConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    get(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Request";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "/" + encodeURIComponent("" + id);
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404 = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : <any>null;

            return throwException("Not Found", status, _responseText, _headers, result404);
        }else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    getAll(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Request";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    create(body: CreateRequestRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201 || status === 409) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = resultData201 !== undefined ? resultData201 : <any>null;

            return Promise.resolve<any>(result201);
        } else if (status !== 201 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Accepted
     */
    update(body: UpdateRequestRequest | undefined , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : <any>null;

            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = resultData409 !== undefined ? resultData409 : <any>null;

            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param estimate (optional)
     * @return Success
     */
    getEstimateData(estimate: string | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Request/GetEstimateData?";
        if (estimate === null)
            throw new Error("The parameter 'estimate' cannot be null.");
        else if (estimate !== undefined)
            url_ += "estimate=" + encodeURIComponent("" + estimate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEstimateData(_response);
        });
    }

    protected processGetEstimateData(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    getBookingList( cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Request/GetBookingList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBookingList(_response);
        });
    }

    protected processGetBookingList(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    getRequestList( cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Request/GetRequestList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequestList(_response);
        });
    }

    protected processGetRequestList(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    getCommercialList( cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Request/GetCommercialList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommercialList(_response);
        });
    }

    protected processGetCommercialList(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param parentId (optional)
     * @return Success
     */
    getSubJobList(parentId: string | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Request/GetSubJobList?";
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubJobList(_response);
        });
    }

    protected processGetSubJobList(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    cancelCreate(id: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Request/CancelCreate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelCreate(_response);
        });
    }

    protected processCancelCreate(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = resultData409 !== undefined ? resultData409 : null as any;

            return throwException("Conflict", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendQuoteCompletedEmail(body: StatusChangeEmail | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Request/SendQuoteCompletedEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendQuoteCompletedEmail(_response);
        });
    }

    protected processSendQuoteCompletedEmail(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class StatusChangeEmail implements IStatusChangeEmail {
    id: string | undefined;
    fileAttachments: string[] | undefined;
    additionalNotes?: string | undefined;

    constructor(data?: IStatusChangeEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["fileAttachments"])) {
                this.fileAttachments = [] as any;
                for (let item of _data["fileAttachments"])
                    this.fileAttachments!.push(item);
            }
            this.additionalNotes = _data["additionalNotes"];
        }
    }

    static fromJS(data: any): StatusChangeEmail {
        data = typeof data === 'object' ? data : {};
        let result = new StatusChangeEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.fileAttachments)) {
            data["fileAttachments"] = [];
            for (let item of this.fileAttachments)
                data["fileAttachments"].push(item);
        }
        data["additionalNotes"] = this.additionalNotes;
        return data;
    }
}

export interface IStatusChangeEmail {
    id: string | undefined;
    fileAttachments: string[] | undefined;
    additionalNotes?: string | undefined;
}

export class CreateRequestRequest implements ICreateRequestRequest {
    estimate: string | undefined;
    additionalRef: string | undefined;
    requestor: string | undefined;
    exchange: string | undefined;
    slaType: number | undefined;
    projectValue: number | undefined;
    workStream: number | undefined;
    workDescription: string | undefined;
    estimatedDays: number | undefined;
    address1: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city: string | undefined;
    county: string | undefined;
    postcode: string | undefined;
    northing: number | undefined;
    easting: number | undefined;
    gridReference?: string;
    dueDate?: Date | undefined;
    parent?: string | undefined;
    addRecipients?: string | undefined;

    constructor(data?: ICreateRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimate = _data["estimate"];
            this.additionalRef = _data["addtionalRef"];
            this.requestor = _data["requestor"];
            this.exchange = _data["exchange"];
            this.slaType = _data["slaType"];
            this.projectValue = _data["projectValue"];
            this.workStream = _data["workStream"];
            this.workDescription = _data["workDescription"];
            this.estimatedDays = _data["estimatedDays"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.postcode = _data["postcode"];
            this.northing = _data["northing"];
            this.easting = _data["easting"];
            this.gridReference = _data["gridReference"];
            this.dueDate = _data["dueDate"];
            this.parent = _data["parent"];
            this.addRecipients = _data["addRecipients"];
        }
    }

    static fromJS(data: any): CreateRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimate"] = this.estimate;
        data["addtionalRef"] = this.additionalRef;
        data["requestor"] = this.requestor;
        data["exchange"] = this.exchange;
        data["slaType"] = this.slaType;
        data["projectValue"] = this.projectValue;
        data["workStream"] = this.workStream;
        data["workDescription"] = this.workDescription;
        data["estimatedDays"] = this.estimatedDays;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city;
        data["county"] = this.county;
        data["postcode"] = this.postcode;
        data["northing"] = this.northing;
        data["easting"] = this.easting;
        data["gridReference"] = this.gridReference;
        data["dueDate"] = this.dueDate;
        data["parent"] = this.parent;
        data["addRecipients"] = this.addRecipients;
        return data;
    }
}

export interface ICreateRequestRequest {
    estimate: string | undefined;
    additionalRef: string | undefined;
    requestor: string | undefined;
    exchange: string | undefined;
    slaType: number | undefined;
    projectValue: number | undefined;
    workStream: number | undefined;
    workDescription: string | undefined;
    estimatedDays: number | undefined;
    address1: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city: string | undefined;
    county: string | undefined;
    postcode: string | undefined;
    northing: number | undefined;
    easting: number | undefined;
    gridReference?: string | undefined;
    dueDate?: Date | undefined;
    parent?: string | undefined;
    addRecipients?: string | undefined;
}

export class UpdateRequestRequest implements IUpdateRequestRequest {
    id: string | undefined;
    estimate: string | undefined;
    additionalRef: string | undefined;
    exchange: string | undefined;
    slaType: number | undefined;
    quoteStatus: number | undefined;
    projectValue: number | undefined;
    workStream: number | undefined;
    workDescription: string | undefined;
    estimatedDays: number | undefined;
    address1: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city: string | undefined;
    county: string | undefined;
    postcode: string | undefined;
    northing: number | undefined;
    easting: number | undefined;
    gridReference?: string |undefined;
    dueDate?: Date | undefined;
    costClaimable: number | undefined;
    quoteValue: number | undefined;
    jobPriority: number | undefined;
    jobType: number[] | undefined;
    jobDetail: string | undefined;
    slipNumber: string | undefined;
    jobStartDate: Date | undefined;
    endType: number | undefined;
    jobEndDate: Date | undefined;
    selectedDays: Date[] | undefined;
    noParkingRequired: boolean | undefined;
    weekendWorks: boolean | undefined;
    busStop: number | undefined;
    dayOnly: boolean | undefined;
    civilsName: string | undefined;
    civilsEmail: string | undefined;
    civilsPhone: string | undefined;
    siteDocsComplete: boolean | undefined;
    invoiceNumber?: string | undefined;
    jobStatus: number | undefined;
    addRecipients?: string | undefined;
    permitRef?: string | undefined;
    permitStatus?: number | undefined;
    commercialStatus?: number | undefined;
    dfeStatus?: number | undefined;
    uplift?: number | undefined;
    dfeValue?: number | undefined;
    sentToDepotnet?: boolean | undefined;
    actualCost?: number | undefined;

    constructor(data?: IUpdateRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.estimate = _data["estimate"];
            this.exchange = _data["exchange"];
            this.additionalRef = _data["additionalRef"];
            this.slaType = _data["slaType"];
            this.quoteStatus = _data["quoteStatus"];
            this.projectValue = _data["projectValue"];
            this.workStream = _data["workStream"];
            this.workDescription = _data["workDescription"];
            this.estimatedDays = _data["estimatedDays"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.postcode = _data["postcode"];
            this.northing = _data["northing"];
            this.easting = _data["easting"];
            this.gridReference = _data["gridReference"];
            this.dueDate = _data["dueDate"];
            this.costClaimable = _data["costClaimable"];
            this.jobPriority = _data["jobPriority"];
            this.jobType = _data["jobType"];
            this.jobDetail = _data["jobDetail"];
            this.quoteValue = _data["quoteValue"];
            this.slipNumber = _data["slipNumber"];
            this.jobStartDate = _data["jobStartDate"];
            this.endType = _data["endType"];
            this.jobEndDate = _data["jobEndDate"];
            this.selectedDays = _data["selectedDays"];
            this.noParkingRequired = _data["noParkingRequired"];
            this.weekendWorks = _data["weekendWorks"];
            this.busStop = _data["busStop"];
            this.dayOnly = _data["dayOnly"];
            this.civilsName = _data["civilsName"];
            this.civilsEmail = _data["civilsEmail"];
            this.civilsPhone = _data["civilsPhone"];
            this.siteDocsComplete = _data["siteDocsComplete"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.jobStatus = _data["jobStatus"];
            this.addRecipients = _data["addRecipients"];
            this.permitRef = _data["permitRef"];
            this.permitStatus = _data["permitStatus"];
            this.commercialStatus = _data["commercialStatus"];
            this.dfeStatus = _data["dfeStatus"];
            this.uplift = _data["uplift"];
            this.dfeValue = _data["dfeValue"];
            this.sentToDepotnet = _data["sentToDepotnet"];
            this.actualCost = _data["actualCost"];
        }
    }

    static fromJS(data: any): UpdateRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["estimate"] = this.estimate;
        data["additionalRef"] = this.additionalRef;
        data["exchange"] = this.exchange;
        data["slaType"] = this.slaType;
        data["projectValue"] = this.projectValue;
        data["quoteStatus"] = this.quoteStatus;
        data["workStream"] = this.workStream;
        data["costClaimable"] = this.costClaimable;
        data["jobPriority"] = this.jobPriority;
        data["jobType"] = this.jobType;
        data["jobDetail"] = this.jobDetail;
        data["quoteValue"] = this.quoteValue;
        data["workDescription"] = this.workDescription;
        data["estimatedDays"] = this.estimatedDays;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city;
        data["county"] = this.county;
        data["postcode"] = this.postcode;
        data["northing"] = this.northing;
        data["easting"] = this.easting;
        data["gridReference"] = this.gridReference;
        data["dueDate"] = this.dueDate;
        data["slipNumber"] = this.slipNumber;
        data["jobStartDate"] = this.jobStartDate;
        data["endType"] = this.endType;
        data["jobEndDate"] = this.jobEndDate;
        data["selectedDays"] = this.selectedDays;
        data["noParkingRequired"] = this.noParkingRequired;
        data["weekendWorks"] = this.weekendWorks;
        data["busStop"] = this.busStop;
        data["dayOnly"] = this.dayOnly;
        data["civilsName"] = this.civilsName;
        data["civilsEmail"] = this.civilsEmail;
        data["civilsPhone"] = this.civilsPhone;
        data["siteDocsComplete"] = this.siteDocsComplete;
        data["invoiceNumber"] = this.invoiceNumber;
        data["jobStatus"] = this.jobStatus;
        data["addRecipients"] = this.addRecipients;
        data["permitRef"] = this.permitRef;
        data["permitStatus"] = this.permitStatus;
        data["commercialStatus"] = this.commercialStatus;
        data["dfeStatus"] = this.dfeStatus;
        data["uplift"] = this.uplift;
        data["dfeValue"] = this.dfeValue;
        data["sentToDepotnet"] = this.sentToDepotnet;
        data["actualCost"] = this.actualCost;

        return data;
    }
}

export interface IUpdateRequestRequest {
    id: string | undefined;
    estimate: string | undefined;
    additionalRef: string | undefined;
    exchange: string | undefined;
    slaType: number | undefined;
    quoteStatus: number | undefined;
    projectValue: number | undefined;
    workStream: number | undefined;
    workDescription: string | undefined;
    estimatedDays: number | undefined;
    address1: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city: string | undefined;
    county: string | undefined;
    postcode: string | undefined;
    northing: number | undefined;
    easting: number | undefined;
    gridReference?: string |undefined;
    dueDate?: Date | undefined;
    costClaimable: number | undefined;
    quoteValue: number | undefined;
    jobPriority: number | undefined;
    jobType: number[] | undefined;
    jobDetail: string | undefined;
    slipNumber: string | undefined;
    jobStartDate: Date | undefined;
    endType: number | undefined;
    jobEndDate: Date | undefined;
    selectedDays: Date[] | undefined;
    noParkingRequired: boolean | undefined;
    weekendWorks: boolean | undefined;
    busStop: number | undefined;
    dayOnly: boolean | undefined;
    civilsName: string | undefined;
    civilsEmail: string | undefined;
    civilsPhone: string | undefined;
    siteDocsComplete: boolean | undefined;
    invoiceNumber?: string | undefined;
    jobStatus: number | undefined;
    addRecipients?: string | undefined;
    permitRef?: string | undefined;
    permitStatus?: number | undefined;
    commercialStatus?: number | undefined;
    dfeStatus?: number | undefined;
    uplift?: number | undefined;
    dfeValue?: number | undefined;
    sentToDepotnet?: boolean | undefined;
    actualCost?: number | undefined;
}

//region :: Imports ::

//endregion

/** */
